async function e(e){return await e.request({method:"wallet_getPermissions"})}export{e as getPermissions};
